import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getArrangementsList } from '../store/actions/arrangements';
import { Link } from 'react-router-dom';
import MasonryTiles from '../components/Masonry';
import SearchBox from '../components/SearchBox';
import PopUp from 'components/popup/PopUp';
import { getToken } from '../store/actions/token';
import { WardrobesConfigsContext } from '../contexts/WardrobesConfigsContext';
import { reactLocalStorage } from 'reactjs-localstorage';

class StartScreen extends Component {
  componentDidMount() {
    this.props.getArrangementsList();
    if (this.props.token === null) {
      this.props.getToken(true);
    }
  }

  static contextType = WardrobesConfigsContext;

  componentDidUpdate() {
    const context = this.context;
    if (context.wardrobesConfigs.length) {
      context.setWardrobesConfigs([]);
    }
  }

  closeConfiguration(link) {
    window.location.replace(link);
  }

  render() {
    const { arrangementsList } = this.props;
    const historyPath = localStorage.getItem('historyPath');
    const link = historyPath !== null ? historyPath : 'https://www.brw.pl';
    return (
      <div className="start-screen">
        <div className="start-screen__bar">
          <div className="start-screen__logo-title">
            <div className="start-screen__logo-title-wrapper">
              <span className="start-screen__logo-first-word">Konfigurator</span>
              <span className="start-screen__logo-second-word">&nbsp;szaf flex</span>
            </div>
          </div>
          <div className="start-screen__logo">
            <img
              src={`${process.env.PUBLIC_URL}/img/svg-illustrations/flex.svg`}
              alt="Konfigurator flex"
            />
          </div>
          <SearchBox placeholder="Wpisz numer konfiguracji" />
          <button className="logo-text" onClick={() => this.closeConfiguration(link)}>
            <p>Zamknij konfigurator</p> <span className="icon-plus" />
          </button>
        </div>
        <div className="start-screen__flex">
          <div className="masonry__tile-wrapper masonry__tile-wrapper--hide-on-desktop">
            <div className="title__box">
              <span className="title title--first-word">Otwórz</span>
              <span className="title title--secound-word">konfigurator</span>
            </div>
            <Link
              to="/height-settings"
              className="container start-screen__box start-screen__box--main">
              <span className="masonry__tile-button">
                OTWÓRZ <i className="icon-small-arrow"></i>
              </span>
            </Link>
          </div>
        </div>
        {!!arrangementsList && <MasonryTiles arrangements={arrangementsList} />}
        {!!reactLocalStorage.get('configurationHaveNotAvalibleItems') && (
          <PopUp
            show
            title=" "
            popupName="configurationHaveNotAvalibleItems-popup"
            buttonText="Ok"
            additionalFunc={() => reactLocalStorage.remove('configurationHaveNotAvalibleItems')}>
            <p>
              Przepraszamy, konfiguracja posiada niedostępny element (
              {reactLocalStorage.get('configurationHaveNotAvalibleItems')}). <br />
              Stwórz ponownie szafę
            </p>
          </PopUp>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    arrangementsList: state.arrangements.arrangementsList,
    token: state.token.token,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getArrangementsList: () => dispatch(getArrangementsList()),
    getToken: (force = false) => dispatch(getToken(force)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StartScreen);
